export const SET_PRIMARY_TAB = 'SET_PRIMARY_TAB'
export const SET_SECONDARY_TAB = 'SET_SECONDARY_TAB'
export const SET_GIFTCARDS = 'SET_GIFTCARDS'
export const SET_GIFTCARD = 'SET_GIFTCARD'
export const SET_PLAYCARDS = 'SET_PLAYCARDS'
export const SET_PLAYCARD = 'SET_PLAYCARD'
export const SET_MEMBERSHIPS = 'SET_MEMBERSHIPS'

export const SET_LOADING_MEMBERSHIPS = 'SET_LOADING_MEMBERSHIPS'
export const SET_LOADING_GIFTCARDS = 'SET_LOADING_GIFTCARDS'
export const SET_LOADING_PLAYCARDS = 'SET_LOADING_PLAYCARDS'

